import { setUserPreviousPath } from 'actions/adminActions'
import { appRoutes } from 'config/routes'
import get from 'lodash/get'
import GDPRPage from 'pages/GDPR'
import ToSPage from 'pages/ToS'
import React, { lazy, useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

const LoginContainer = lazy(() => import('pages/loginContainer'))
const RegistrationContainer = lazy(() => import('pages/registrationContainer'))

const UnAuthenticated: React.FC<{
  setUserPreviousPath: (path: string) => void
}> = ({ setUserPreviousPath }) => {
  const location = useLocation()

  useEffect(() => {
    const prevPath = get(location, ['pathname'])
    const params = get(location, ['search'], '')
    // if the user is attempting to go to a route in our app that is not /login
    // we want to store that route state.appState.userPreviousPath
    // so that once they have successfully logged in, we'll send them back to that path
    if (
      prevPath &&
      prevPath !== appRoutes.login &&
      prevPath !== appRoutes.sessionExpired
    ) {
      setUserPreviousPath(`${prevPath}${params}`)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="full-content-wrapper legacy-typography">
      <Switch>
        <Route
          path={`${appRoutes.login}/:journey?`}
          render={() => <LoginContainer />}
        />
        <Route
          path={`${appRoutes.register}/:journey?`}
          render={() => <RegistrationContainer />}
        />
        <Route path={appRoutes.tos} render={() => <ToSPage />} />
        <Route path={appRoutes.gdpr} render={() => <GDPRPage />} />
        <Route
          path="/"
          render={() => <Redirect to={{ pathname: appRoutes.login }} />}
        />
      </Switch>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  setUserPreviousPath: (path: string) => dispatch(setUserPreviousPath(path))
})

export default connect(null, mapDispatchToProps)(UnAuthenticated)
